module.exports = __webpack_public_path__ + "img/metrovia.efe07749.jpeg";